import React from 'react';

import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import HorizontalFeed from '@/components/core/components/molecules/horizontal-feed';
import { ProductType } from '@/@types';
import * as styles from './more-like-this.styles';

const MoreLikeThis: UIComponent<{ product: ProductType }> = ({ product, className }) => {
  if (!product.related || product.related.length === 0) {
    return null;
  }
  return (
    <div className={clsx(styles.root, className)}>
      <h3 className={styles.title}>
        <Trans>More like {product.name}</Trans>
      </h3>
      <HorizontalFeed
        items={product.related.map((p) => {
          return { product: p, type: 'product' };
        })}
      />
    </div>
  );
};

export default MoreLikeThis;
